//import '../assets/css/styles.css';
import './js/main';

import "@lottiefiles/lottie-player";

const sectionSliders = document.querySelectorAll('.section-slider');
if (sectionSliders.length > 0) {
    import('./js/slider').then(Slider => {
        new Slider.default();
    }).catch(err => {
        console.error('Failed to load Slider module:', err);
    });
}
